const postReducer = (state = null, action) => {
    switch (action.type) {
        case 'POST_SEARCH':
            if (action.data != null) {
                return JSON.stringify(action.data)
            }
            return null

        case 'SIGN_OUT':
            return null
        case 'RESET':
            return null
        default:
            return state
    }
}

export default postReducer
